'use client';
import { useAuth } from '@shared/common/providers/AuthProvider';

import { PredictionEntries } from './PredictionEntries/PredictionEntries';
import { PredictionMyResults } from './PredictionMyResults/PredictionMyResults';

export const PredictionUserDashboardSection = () => {
  const { userEvmWallet } = useAuth();

  return (
    userEvmWallet?.attributes?.address && (
      <div className="flex flex-col gap-10 lg:gap-14 w-full">
        <PredictionMyResults />
        <PredictionEntries />
      </div>
    )
  );
};
